var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundRemover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#47B7CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0078 16.8828L23.4344 24.3094",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 29.6031H13.8859L9.82813 25.5453C9.66476 25.3836 9.53508 25.1911 9.44657 24.979C9.35807 24.7668 9.3125 24.5392 9.3125 24.3094C9.3125 24.0795 9.35807 23.8519 9.44657 23.6398C9.53508 23.4276 9.66476 23.2351 9.82813 23.0734L22.1984 10.7031C22.3601 10.5398 22.5526 10.4101 22.7648 10.3216C22.9769 10.2331 23.2045 10.1875 23.4344 10.1875C23.6642 10.1875 23.8918 10.2331 24.104 10.3216C24.3161 10.4101 24.5086 10.5398 24.6703 10.7031L29.625 15.6469C29.9503 15.9782 30.1326 16.424 30.1326 16.8883C30.1326 17.3526 29.9503 17.7984 29.625 18.1297L18.1406 29.6031",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundRemover);
export default __webpack_public_path__ + "static/media/background-remover.e29d97702a60cdbc291fbe4068b17b65.svg";
export { ForwardRef as ReactComponent };